import React from 'react';

import { TypeTextFixedIcon } from '../../../../images/icons/WrapSvg';
import Task from './Task';

class Index extends React.Component {
    UNSAFE_componentWillMount() {
        const { data } = this.props;
        this.setState({ data: data, value: data.nombre });
    }

    component = (value) => {
        return <span className="barlow_regular_textwrap c_slate text_align_left flex_full_row padding_top_18">{value}</span>;
    };

    render() {
        const { data, last, editable } = this.props;
        return (
            <Task
                key={data.codigo}
                data={data}
                desactivado={false}
                icon={<TypeTextFixedIcon color="primary" />}
                text="type_label_textfixed"
                last={last}
                editable={editable}
                component={this.component(data.descripcion)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/TextFixed.js